import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, AfterViewInit } from '@angular/core';
import { MyLoadingComponent } from './components/my-loading/my-loading.component';
import { RouterModule } from '@angular/router';
import { environment } from '../environments/environment';
import { MyBreadcrumbComponent } from "./components/my-breadcrumb/my-breadcrumb.component";
import { DefaultsService, GovBrAlertMessagesModule } from '@serpro/ngx-dsgovbr';
import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { Observable, Subscription } from 'rxjs';
import { DispositivoService } from './services/dispositivo.service';
import { MyVersionComponent } from './components/diversos/my-version/my-version.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    MyLoadingComponent,
    RouterModule,
    MyBreadcrumbComponent,
    GovBrAlertMessagesModule,
    MainLayoutComponent,
    MyVersionComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements OnInit, AfterViewInit {

  private subscriptions: Subscription = new Subscription();

  dispositivo: string = '';

  isOffline: boolean = environment.profile === 'offline';
  //isOffline: boolean = true;

  title = 'Calculadora';

  scriptTag: any;

  constructor(
    private dispositivoService: DispositivoService,
    private defaultsService: DefaultsService,
  ) { }



  ngOnInit(): void {

    this.defaultsService.labelRequired = '';

    if (!this.isOffline) {
      this.scriptTag = document.createElement("script");
      this.scriptTag.src = "/webcomponents/v2/main.js";
      document.body.appendChild(this.scriptTag);
    }

    this.dispositivoService.checarDispositivo();
    this.setSubscriptions();

  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  setSubscriptions() {
    this.subscriptions.add(
      this.dispositivoService.dispositivo$.subscribe((dispositivo) => {
        this.dispositivo = dispositivo;
      })
    );
  }


}
